import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()(() => ({
  buttonStyleDisconnected: {
    color: "#FF1B1B",
    backgroundColor: "#FF1B1B3D",
    border: "none",
    borderRadius: "6px",
    textTransform: "capitalize",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "#FF1B1B1A",
      border: "none",
    },
  },
  box: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  buttonStyleConnected: {
    color: "#4D1277",
    backgroundColor: "#4D127733",
    border: "none",
    borderRadius: "6px",
    textTransform: "capitalize",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "#4D12771A",
      border: "none",
    },
  },
  headerBox: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "40px",
  },
  avtarStyle: {
    height: "40px",
    width: "40px",
  },
  textHead: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  headerHeading: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#272525",
  },
  headerSubHeading: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#999999",
  },
  lowerBox: {
    display: "flex",
    justifyContent: "center",
    gap: "50px",
    width: "100%",
  },
  lowerBoxLeft: {
    width: "100%",
  },
  lowerBoxRight: {
    width: "100%",
  },
  formControl: {
    display: "block",
  },
  formInput: {
    width: "100%",
    height: "50px",
    borderRadius: "5px",
    border: "1px solid #9999994D",
  },
  inputLabel: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#000000",
    textTransform: "capitalize",
    display: "block",
  },
  buttonStyle: {
    borderRadius: "6px",
    backgroundColor: "#4D1277",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#FFFFFF",
    width: "100%",
    padding: "8px 10px",
    marginTop: "20px",
  },
  text: {
    width: "100%",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "400",
    color: "#999999",
    marginTop: "10px",
  },
  errorText: {
    marginLeft: "0",
  },
  replySection: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "20px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#000000",
    textAlign: "center",
  },
  internalCard: {
    height: "400px",
    width: "100%",
    margin: "20px 0px 148px 0px",
    borderRadius: "5px",
    boxShadow: "0px 2px 5px 0px rgba(0, 0, 0, 0.05)",
    marginLeft: "-20px",
  },
}));

export default useStyle;
